import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberToTime',
})
export class NumberToTimePipe implements PipeTransform {
  transform(value: number | string | null, args: 'HH:mm' | 'string'): string {
    if (typeof value === 'string') {
      return '-';
    }
    return numberToTimePipe(args, value);
  }
}

// export const numberToTimePipe = (opt: 'HH:mm' | 'string', num: number | null): string => {
//   if (num) {
//     const time: { minutes: number; hours: number } = { minutes: 0, hours: num };
//     const abs = Math.abs(num);
//     time.hours = Math.floor(abs);
//     time.minutes = Math.round((abs - time.hours) * 60);
//     if (num < 0) {
//       return opt === 'HH:mm'
//         ? `-${time.hours === 0 ? '' : time.hours + 'h'} ${
//             time.minutes === 0 ? '' : time.minutes + 'm'
//           }`
//         : `-${time.hours === 0 ? '' : time.hours + 'ore'} ${
//             time.hours !== 0 && time.minutes !== 0 ? 'e' : ''
//           } ${time.minutes === 0 ? '' : time.minutes + ''}`;
//     }
//     return opt === 'HH:mm'
//       ? `${time.hours === 0 ? '' : time.hours + 'h'} ${
//           time.minutes === 0 ? '' : time.minutes + 'm'
//         }`
//       : `${time.hours === 0 ? '' : time.hours + 'ore'} ${
//           time.hours !== 0 && time.minutes !== 0 ? 'e' : ''
//         } ${time.minutes === 0 ? '' : time.minutes + ''}`;
//   } else {
//     return '-';
//   }
// };

export const numberToTimePipe = (opt: 'HH:mm' | 'string', num: number | null): string => {
  if (num === null || num === undefined) {
    return '-';
  }

  const isNegative = num < 0;
  const abs = Math.abs(num);

  const totalMinutes = Math.round(abs * 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (opt === 'HH:mm') {
    return `${isNegative ? '-' : ''}${hours === 0 ? '' : hours + 'h'} ${
      minutes === 0 ? '' : minutes + 'm'
    }`.trim();
  }

  return `${isNegative ? '-' : ''}${hours === 0 ? '' : hours + 'ore'}${
    hours !== 0 && minutes !== 0 ? ' e ' : ' '
  }${minutes === 0 ? '' : minutes}`.trim();
};
